<template>
  <auth-layout pageClass="login-page">
    <div id="loading-wrapper" ref="loadingWrapper">
			<div class="spinner">
				<div class="line1"></div>
				<div class="line2"></div>
				<div class="line3"></div>
				<div class="line4"></div>
				<div class="line5"></div>
				<div class="line6"></div>
			</div>
		</div>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <ValidationObserver v-slot="{ handleSubmit }">
          <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
          <form @submit.prevent="handleSubmit(submit)">
            <fade-render-transition>
              <card>
                <div slot="header">
                  <div class="logo-container text-center">
                    <img src="static/img/kings-logo-lion.png" alt="Editorial King's" width="160" />
                  </div>
                  <h3 class="card-title text-center">Iniciar sesión</h3>
                </div>
                <div>
                  <ValidationProvider
                    name="email"
                    rules="required|email"
                    v-slot="{ passed, failed }"
                  >
                    <fg-input
                      type="email"
                      :error="failed ? 'El correo es requerido' : null"
                      :hasSuccess="passed"
                      label="Correo electrónico"
                      name="email"
                      v-model="email"
                    >
                    </fg-input>
                  </ValidationProvider>
                  <ValidationProvider
                    name="password"
                    rules="required|min:3"
                    v-slot="{ passed, failed }"
                  >
                    <fg-input
                      type="password"
                      :error="failed ? 'La clave es requerida' : null"
                      :hasSuccess="passed"
                      name="password"
                      label="Clave"
                      v-model="password"
                    >
                    </fg-input>
                  </ValidationProvider>
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-fill btn-info btn-round btn-wd">
                    Iniciar sesión
                  </button>
                  <br />
                  <div class="forgot"></div>
                </div>
              </card>
            </fade-render-transition>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </auth-layout>
</template>
<script>
import { FadeRenderTransition } from "src/components/index";
import AuthLayout from "./AuthLayout.vue";
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import axios from "axios";
import Swal from 'sweetalert2'

extend("email", email);
extend("required", required);
extend("min", min);

export default {
  components: {
    FadeRenderTransition,
    AuthLayout,
  },
  data() {
    return {
      email: "",
      password: "",
      subscribe: true,
    };
  },
  mounted() {
    this.$refs.loadingWrapper.style.display = "none";
  },
  methods: {
    async submit() {
      // alert("Form has been submitted!");
      this.$refs.loadingWrapper.style.display = "block";
      await axios
        .post("https://api.editorialkings.com/public/login", {
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          const jwt = {
            value: response.data.message.Authorization,
            expiry: Date.now() + 1000 * 60 * 60 * 6, //6h
          }

          localStorage.setItem('jwt', JSON.stringify(jwt));
          let user = {
            email: response.data.message.email,
            name: response.data.message.name,
            avatar: response.data.message.avatar,
            role: response.data.message.role,
            uuid: response.data.message.uuid,
          }
          localStorage.setItem('user', JSON.stringify(user));

          if (user.role === 'Autor') {
            this.$router.push({ path: "/author" });
          } else {
            this.$router.push({ path: "/dashboard" });
          }
        })
        .catch((error) => {
          // notify error
          this.$refs.loadingWrapper.style.display = "none";
          Swal.fire({
            title: this.$systemVariables.wereSorry,
            text: this.$systemVariables.loginError,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-danger btn-fill'
          });
        });
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      document.body.classList.remove("off-canvas-sidebar");
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
